// extracted by mini-css-extract-plugin
export default {"heading_container":"Heading_heading_container__1CmZd","heading":"Heading_heading__8G7oC"};